import PubSub from 'pubsub-js';
import React from 'react';
import { useQuery } from '@apollo/client';

import { Mutation } from '@apollo/client/react/components';
import { EDIT_TITLE_BY_CONTENTMANAGER_ID, GET_TITLE_CONTENT_BY_ID } from '../../../queries/titleContent';
import Form from '../components/form';

const useFetchTitle = (id: string) => useQuery(GET_TITLE_CONTENT_BY_ID, {
  variables: { id },
  fetchPolicy: 'network-only',
});

interface IUpdateTitlesProps {
  titleId: string;
  refetchTitles: () => void;
  onCloseDrawer: () => void;
}

const UpdateTitles: React.FC<IUpdateTitlesProps> = ({ titleId, refetchTitles, onCloseDrawer }) => {
  const title = useFetchTitle(titleId);

  if (title.loading) return <>Loading...</>;
  if (title.error) {
    return (
      <>{`Error! ${title.error.message}`}</>
    );
  }

  return (
    <Mutation
      mutation={EDIT_TITLE_BY_CONTENTMANAGER_ID}
      update={async () => {
        PubSub.publish('CLOSE-DRAWER', 'right');
        refetchTitles();
        onCloseDrawer();
      }}
    >
      {(updateTitleAsContentManager: any) => (
        <Form
          query_f={updateTitleAsContentManager}
          data={title.data.titleContent.titles[0]}
        />
      )}
    </Mutation>
  );
};

export default UpdateTitles;
